import { render, staticRenderFns } from "./ActiveFatigueDashboard.vue?vue&type=template&id=63400b02&"
import script from "./ActiveFatigueDashboard.vue?vue&type=script&lang=js&"
export * from "./ActiveFatigueDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports